<template>
  <naj-button @click="clickHandler" :outlined="outlined">
    {{ label }}
  </naj-button>
</template>

<script>
import Methods from '@/modules/global/components/dynamic-form/methods/index';
import { executeString } from '@/helpers/utils';
export default {
  name: 'naj-dynamic-button',
  props: {
    label: {
      type: String,
      required: true,
    },
    formModel: {
      type: Object,
      required: true,
    },
    rootFormModel: {
      type: Object,
      required: true,
    },
    clickCallback: {
      type: Function,
      required: true,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      executeString,
    };
  },
  methods: {
    fireUpdate () {
      const testValue = 'testValueForUpdateValue';
      // we do this to fire manual render for the dynamic form component
      this.$set(this.formModel, testValue, !this.formModel[testValue]);
    },
    generateCallbackMethod(){
      const clickObject = this.clickCallback();
      if(clickObject.isPureCode){
        executeString(clickObject.code, {...this.rootFormModel, ...Methods})
      } else{
        const params = Object.keys(clickObject.params).reduce((paramsObj, param) => {
          paramsObj[param] = executeString(clickObject.params[param], this.rootFormModel);
          return paramsObj;
        }, {});
        const returnValue = Methods[clickObject.methodName].call(params);
        if(returnValue && returnValue.hasOutput) {
          for(let index in returnValue.outputParams){
            const paramObj = returnValue.outputParams[index];
            this.formModel[paramObj.outputParam] = paramObj.value;
          }
        }
      }
    },
    clickHandler () {
      const callbackResults = this.generateCallbackMethod();
      if (callbackResults instanceof Promise) {
        callbackResults.then(this.fireUpdate);
      } else {
        this.fireUpdate();
      }
    },
  },
};
</script>
